var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "filters-container",
      class: _vm.isSticking ? "sticky" : "",
      attrs: { id: "filters" }
    },
    [
      _c("div", { staticClass: "filters-internal" }, [
        _c(
          "div",
          { staticClass: "filter-header", on: { click: _vm.expandFilters } },
          [
            _c("img", {
              attrs: {
                src:
                  "https://happyboxstore.com/cdn/shop/files/Group_1790.png?v=1720194132"
              }
            }),
            _vm._v(" "),
            _c("p", [
              _vm._v("Filters "),
              _vm.totalCurrentFilters > 0
                ? _c("span", [
                    _vm._v("(" + _vm._s(_vm.totalCurrentFilters) + ")")
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("img", {
              class: _vm.isExpanded ? "flipped" : "",
              attrs: {
                src:
                  "https://happyboxstore.com/cdn/shop/files/Group_3438.png?v=1720194132"
              }
            })
          ]
        ),
        _vm._v(" "),
        _vm.isExpanded
          ? _c(
              "div",
              [
                _c("CategoriesFilter", {
                  attrs: { categoriesArray: _vm.categoryFilters },
                  on: { goall: _vm.goAll }
                }),
                _vm._v(" "),
                _c("OccasionFilter", {
                  attrs: { occasions: _vm.occasionsFilters }
                }),
                _vm._v(" "),
                _vm.maxMinPrices
                  ? _c("PriceFilter", {
                      attrs: { prices: _vm.maxMinPrices },
                      on: { goall: _vm.goAll }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.mappedFilters, function(filters) {
                  return _c("GenericFilter", {
                    key: filters.category,
                    attrs: {
                      filteredAddons: _vm.filteredAddons,
                      filters: filters
                    },
                    on: { goall: _vm.goAll }
                  })
                }),
                _vm._v(" "),
                _vm.totalCurrentFilters > 0
                  ? _c("div", { staticClass: "reset-button" }, [
                      _c(
                        "button",
                        {
                          staticClass: "happybox-button white border",
                          on: { click: _vm.resetFilters }
                        },
                        [_vm._v("RESET")]
                      )
                    ])
                  : _vm._e()
              ],
              2
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }